import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
import {
  LoginStepType,
  LoginUserDataType
} from "@website/widget/login/login.types";
import { useCallback, useEffect, useState } from "react";

export const useLogin = () => {
  const router = useCompatRouter();
  const queryString = "login_step";

  const setStep = useCallback(
    (step: LoginStepType) => {
      router &&
        router?.replace(
          router?.pathname,
          { ...router?.query, [queryString]: step },
          { shallow: true, scroll: false }
        );
    },
    [router]
  );

  const [userData, setUserData] = useState<LoginUserDataType>({
    phoneNumber: "",
    userExists: false,
    hasPassword: false,
    accessToken: "",
    refreshToken: "",
    forgotPassword: false,
    message: "",
    otpLength: 0,
    otpValidUntil: 0,
    otpId: "",
    otp: ""
  });

  useEffect(() => {
    if (!userData?.phoneNumber) setStep("phone-number");
  }, [userData?.phoneNumber]);

  return {
    step: (router?.query?.[queryString] as LoginStepType) || "phone-number",
    setStep,
    userData,
    setUserData
  };
};
